import { useDispatch } from 'react-redux'
import { ActionSidebar } from 'redux/optime/optime'
import { addEditDataAPI } from 'services/CRUDServices'

export const useUpdateZone = () => {
  const dispatch=useDispatch()
 async function updateAPI(item) {
  
   await addEditDataAPI('/core-api/hub/zone/editSubzone', 'put', {
      id: item.id,
      selectHub: item.selectHub,
      countrydevision: {
        id: item.id,
        text: item.name,
      },
      selectuser: {
        id: '444',
        text: '',
      },
      countrytype: item.countryType,
      polygon: `[[\n ${item.createdZone.map(
          (item: any) => `\n ${JSON.stringify(item)}` //convert polygon coordinates for backend schema
        )},\n],\n];`,
    })

  }

  return { updateAPI }
}
